import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
    userUUID: string;
    email: string;
    iat: number;
    exp: number;
    [key: string]: any;
}

/**
 * Хук для роботи з JWT токенами
 * @returns Функції для роботи з JWT
 */
export const useJwtDecode = () => {
    /**
     * Декодує JWT токен
     * @param token JWT токен
     * @returns Розшифрований JWT payload або null у випадку помилки
     */
    const decodeToken = (token: string): JwtPayload | null => {
        try {
            return jwtDecode<JwtPayload>(token);
        } catch (error) {
            console.error('Помилка при декодуванні JWT токена:', error);
            return null;
        }
    };

    /**
     * Отримує UUID користувача з JWT токена
     * @param token JWT токен
     * @returns UUID користувача або null у випадку помилки
     */
    const getUserUuidFromToken = (token: string): string | null => {
        const decoded = decodeToken(token);
        return decoded?.userUUID || null;
    };

    /**
     * Перевіряє, чи токен дійсний (не прострочений)
     * @param token JWT токен
     * @returns true, якщо токен дійсний, false - якщо прострочений або невалідний
     */
    const isTokenValid = (token: string): boolean => {
        try {
            const decoded = decodeToken(token);
            if (!decoded) return false;

            const currentTime = Math.floor(Date.now() / 1000);
            return decoded.exp > currentTime;
        } catch (error) {
            return false;
        }
    };

    return {
        decodeToken,
        getUserUuidFromToken,
        isTokenValid
    };
}; 